// The /jobs index page — the first page served by the shell itself instead
// of the federated remote (JobsDashboard parity: banner, header, container).
// Normal page flow: the table virtualizes against the SHELL PANEL's scroll
// (JobsTable's scrollMargin), so the page owns no scroller and the
// banner/toolbar scroll away like any other page content.

import { Box, Flex, Heading } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { organizationQueryOptions } from '../../lib/jobs/queries';
import { MyJobs } from './MyJobs';
import {
    Aria1RetirementBanner,
    PAGE_CONTENT_PX,
    PAGE_MAX_WIDTH,
} from './page-chrome';

export default function JobsPage() {
    const organizationQuery = useQuery(organizationQueryOptions());

    return (
        // The page is normal flow like every other; the table virtualizes
        // against the shell panel's scroll (JobsTable's scrollMargin), so
        // no viewport pinning.
        <Flex direction='column'>
            {/* The visual header is gone, but the document outline keeps
                its single h1 for heading navigation. */}
            <Heading as='h1' srOnly>
                My Jobs
            </Heading>
            <Aria1RetirementBanner
                allowExtraTargets={organizationQuery.data?.allowExtraTargets}
            />
            {/* No ViewHeader (page-chrome keeps the component): the toolbar
                is the page's top edge — pt adds the breathing room the
                header strip used to provide. */}
            <Box
                px={PAGE_CONTENT_PX}
                pt={4}
                flex='1'
                minH='0'
                display='flex'
                flexDirection='column'
            >
                <Box
                    maxW={PAGE_MAX_WIDTH}
                    marginX='auto'
                    width='100%'
                    flex='1'
                    minH='0'
                    display='flex'
                    flexDirection='column'
                >
                    <MyJobs />
                </Box>
            </Box>
        </Flex>
    );
}
